module.exports = __webpack_public_path__ + "img/2.faedd5ee.png";